<template>
  <a-row :gutter="20" class="AccountUser w-100">
    <a-col :span="isDesktop ? 16 : 24">
      <a-card title="Users" class="style1 user-list">
        <p v-if="empty(userList)" style="text-align: center; font-size: 24px;">No user</p>
        <ul v-else>
          <li v-for="user in userList" :key="user.key" @click="selectUser(user)" :class="`${isMobile ? 'mobile' : ''} ${selected === user.id ? 'selected' : ''}`">
            <div>
              <b style="font-size: 20px;">{{ `${user.firstname || ''} ${user.lastname || ''}` }}</b>
              <p>
                <b>Email:</b>
                {{ user.email }}
              </p>
              <p v-if="!empty(user.phone)">
                <b>Phone:</b>
                {{ user.phone }}
              </p>
              <p v-if="!empty(user.cellphone)">
                <b>Cell Phone:</b>
                {{ user.cellphone }}
              </p>
            </div>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :span="isDesktop ? 8 : 24">
      <a-card :title="updateUserTitle" class="style1" id="formAccountUser">
        <a-form :form="form" :label-col="isDesktop ? { span: 8 } : {}" :wrapper-col="isDesktop ? { span: 16 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
          <a-form-item label="First Name">
            <a-input v-decorator="['firstname', { rules: [{ required: true, message: 'Please input first name!' }] }]" />
          </a-form-item>
          <a-form-item label="Last Name">
            <a-input v-decorator="['lastname', { rules: [{ required: true, message: 'Please input last name!' }] }]" />
          </a-form-item>
          <a-form-item label="Email">
            <a-input v-decorator="['email', { rules: [{ type: 'email', required: true, message: 'Please input Email!' }] }]" />
          </a-form-item>
          <a-form-item label="Phone">
            <a-input v-decorator="['phone']" />
          </a-form-item>
          <a-form-item label="Cell phone">
            <a-input v-decorator="['cellphone']" />
          </a-form-item>
          <a-form-item label="Password">
            <a-input v-decorator="['password']" />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 24 }">
            <div class="d-flex justify-content-between">
              <a-button type="primary" html-type="submit" :loading="isLoading">{{ updateUserTitle }}</a-button>
              <a-button type="primary" v-if="isUpdate" @click="onResetForm">Create User</a-button>
            </div>
          </a-form-item>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import AdminService from '@/services/AdminService';
import { mapState } from 'vuex';
import { get, map } from 'lodash';
import { empty } from '@/utils';
export default {
  props: {
    accountUsers: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    isLoading: false,
    isUpdate: false,
    userList: [],
    selected: '',
    user_id: null,
  }),

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'account_user' });
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    isMobile() {
      return this.settings.isMobileView;
    },
    updateUserTitle() {
      return this.isUpdate ? 'Update User' : 'Create User';
    },
  },
  watch: {
    accountUsers(data) {
      this.userList = map(data, (item, index) => ({
        ...item,
        key: index,
      }));
    },
  },
  methods: {
    empty,
    onResetForm() {
      this.isUpdate = false;
      this.form.resetFields();
      this.selected = '';
    },
    selectUser(record) {
      this.selected = record.id;
      this.isUpdate = true;
      this.user_id = record.id;
      if (!this.isDesktop) {
        document.getElementById('formAccountUser').scrollIntoView();
      }
      this.$nextTick(() => {
        this.form.setFieldsValue({
          firstname: record.firstname,
          lastname: record.lastname,
          email: record.email,
          phone: record.phone,
          cellphone: record.cellphone,
        });
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            // const dataSubmit = Object.keys(values).reduce((obj, key) => {
            //   if (!empty(values[key])) {
            //     obj[key] = values[key];
            //   }
            //   return obj;
            // }, {});
            await (this.isUpdate ? AdminService.user.update(this.user_id, values) : AdminService.user.create(values));
            this.$emit('onSuccess');
            this.$notification['success']({
              message: 'User',
              description: this.isUpdate ? 'You have successfully updated user information !' : 'You have successfully added new user!',
            });
          } catch (error) {
            console.log(error);
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.AccountUser {
  .user-list {
    .ant-card-body {
      padding: 10px;
      height: 540px;
      overflow: auto;
    }
  }
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #6c757d;
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;
      img {
        max-width: 200px;
      }
      &.mobile {
        flex-direction: column;
        align-items: flex-start;
      }
      &.selected {
        background: rgba(#23c6c8, 0.2);
      }
    }
  }
}
</style>
